import * as m from "@paraglide/messages"
import type { SupportedLocale } from "@site-types/site"

// Left Navbar
export const navMenu = (lang: SupportedLocale) => {
  return [
    {
      page: "work",
      href: `/${lang}/work`,
      icon: "fa fa-sharp fa-thin fa-gamepad-alt",
      label: m.nav_ourWork({}, { locale: lang }),
    },
    {
      page: "calendar",
      href: `/${lang}/calendar`,
      icon: "fa fa-sharp fa-thin fa-tv",
      label: m.nav_watchNow({}, { locale: lang }),
    },
    {
      page: "news",
      href: `/${lang}/news`,
      icon: "fa fa-sharp fa-thin fa-message-lines",
      label: m.nav_news({}, { locale: lang }),
    },
    {
      page: "careers",
      href: `/${lang}/careers`,
      icon: "fa fa-sharp fa-thin fa-users",
      label: m.nav_joinUs({}, { locale: lang }),
    },
    {
      page: "contact",
      href: `/${lang}/contact`,
      icon: "fa fa-sharp fa-thin fa-paper-plane",
      label: m.nav_contact({}, { locale: lang }),
    },
    {
      page: "company",
      href: `/${lang}/company`,
      icon: "fa-sharp fa-thin fa-building",
      label: m.nav_company({}, { locale: lang }),
    },
    {
      page: "index",
      href: m.nav_x_link({}, { locale: lang }),
      icon: "fa fa-brands fa-x-twitter",
      label: m.nav_x({}, { locale: lang }),
      external: true,
    },
  ]
}

// /company
export const companyDetails = (lang: SupportedLocale) => {
  let addressContent = [
    m.company_companyDetails_addressBuilding({}, { locale: lang }),
    m.company_companyDetails_address({}, { locale: lang }),
    m.company_companyDetails_addressKu({}, { locale: lang }),
    m.company_companyDetails_addressCity({}, { locale: lang }),
  ]
  if (lang === "ja") {
    addressContent = [
      m.company_companyDetails_address({}, { locale: lang }),
      m.company_companyDetails_addressBuilding({}, { locale: lang }),
      m.company_companyDetails_addressKu({}, { locale: lang }),
      m.company_companyDetails_addressCity({}, { locale: lang }),
      m.company_companyDetails_addressPostalCode({}, { locale: lang }),
    ]
  }
  return [
    {
      label: m.company_companyDetails_companyNameLabel({}, { locale: lang }),
      content: [
        m.company_companyDetails_pbInc({}, { locale: lang }),
        m.company_companyDetails_pbIncJa({}, { locale: lang }),
      ],
    },
    {
      label: m.company_companyDetails_addressLabel({}, { locale: lang }),
      content: addressContent,
    },
    {
      label: m.company_companyDetails_incorporationDateLabel({}, { locale: lang }),
      content: [m.company_companyDetails_incorporationDate({}, { locale: lang })],
    },
    {
      label: m.company_companyDetails_capitalLabel({}, { locale: lang }),
      content: [m.company_companyDetails_capital({}, { locale: lang })],
    },
    {
      label: m.company_companyDetails_bodLabel({}, { locale: lang }),
      content: [
        m.company_companyDetails_RepDirector({}, { locale: lang }),
        m.company_companyDetails_directorOne({}, { locale: lang }),
        m.company_companyDetails_directorTwo({}, { locale: lang }),
      ],
    },
    {
      label: m.company_companyDetails_businessLabel({}, { locale: lang }),
      content: [m.company_companyDetails_businessDesc({}, { locale: lang })],
    },
  ]
}

// /company
export const sudokuGrid = [
  { row: "row-1", col: "col-3", value: 8 },
  { row: "row-1", col: "col-9", value: 4 },
  { row: "row-2", col: "col-1", value: 4 },
  { row: "row-2", col: "col-7", value: 2 },
  { row: "row-3", col: "col-3", value: 3 },
  { row: "row-3", col: "col-4", value: 5 },
  { row: "row-3", col: "col-9", value: 6 },
  { row: "row-4", col: "col-3", value: 6 },
  { row: "row-4", col: "col-4", value: 2 },
  { row: "row-5", col: "col-6", value: 3 },
  { row: "row-7", col: "col-1", value: 8 },
  { row: "row-7", col: "col-5", value: 3 },
  { row: "row-8", col: "col-1", value: 2 },
  { row: "row-8", col: "col-6", value: 4 },
  { row: "row-8", col: "col-7", value: 8 },
  { row: "row-9", col: "col-1", value: 5 },
  { row: "row-9", col: "col-7", value: 4 },
]

export const careersPoints = (lang: SupportedLocale) => {
  return {
    whatWeDo: [
      m.careers_whatWeDo_streaming({}, { locale: lang }),
      m.careers_whatWeDo_marketing({}, { locale: lang }),
      m.careers_whatWeDo_products({}, { locale: lang }),
      m.careers_whatWeDo_communities({}, { locale: lang }),
      m.careers_whatWeDo_analytics({}, { locale: lang }),
    ],
    whyWeDo: [
      m.careers_whyWeDo_love({}, { locale: lang }),
      m.careers_whyWeDo_thrill({}, { locale: lang }),
      m.careers_whyWeDo_passion({}, { locale: lang }),
      m.careers_whyWeDo_challenge({}, { locale: lang }),
    ],
    gameCompanies: [
      m.gameCompanies_riot({}, { locale: lang }),
      m.gameCompanies_ubisoft({}, { locale: lang }),
      m.gameCompanies_konami({}, { locale: lang }),
      m.gameCompanies_blizzard({}, { locale: lang }),
      m.gameCompanies_supercell({}, { locale: lang }),
      m.gameCompanies_more({}, { locale: lang }),
    ].join(","),
    uniqueWorkplace: [
      m.careers_uniqueWorkplace_multilingual({}, { locale: lang }),
      m.careers_uniqueWorkplace_tokyo({}, { locale: lang }),
    ],
  }
}
